// eslint-disable-next-line import/no-internal-modules
import Icon from '@insided/deprecated-preact-components/assets'

interface AttachmentProps {
  filename: string
  url?: string
  key: number
  onDelete: () => void
}

const Attachment = ({ filename, url, key, onDelete }: AttachmentProps) => {
  return (
    url
    ? (
      <li className='content-attachments-list__item' key={key}>
        <a className='content-attachments-list__link' href={url}>{filename}</a>
        <Icon width='18' height='18' icon='close' customClass='content-attachments__delete' onClick={onDelete} />
      </li>
    )
    : (
      <li className='content-attachments-list__item' key={key}>
        <span className='content-attachments-list__text--loading'>{filename}</span>
        <span style={{ width: '24px', position: 'relative' }}>
          <Icon icon='loader' />
        </span>
      </li>
    )
  )
}

export default Attachment
